import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { addDoc, collection, Timestamp } from 'firebase/firestore'
import { toast } from 'react-toastify'

import { auth, db } from '../firebase'
import { convertTime } from '../helpers/datetime_helper'
import Layout from '../components/layout'
import MainTitle from '../components/main_title'
import { getIconBySentiment } from '../components/icons'
import { User } from 'firebase/auth'

function NewJournal() {
  const user = auth.currentUser as User
  const [title, setTitle] = useState('')
  const [date, setDate] = useState<Date>(new Date())
  const [content, setContent] = useState('')
  const [sentiment, setSentiment] = useState('unknown')
  const navigate = useNavigate() // Navigation

  async function createJournal() {
    const data = {
      uid: user.uid,
      title: title,
      date: date,
      content: content,
      sentiment: sentiment
    }

    await addDoc(collection(db, 'journals'), data)
    navigate('/journals')
    toast.success('Successfully created a new journal')
  }

  function getMaxValueKey(obj: any) {
    return Object.keys(obj).reduce((a, b) => (obj[a] > obj[b] ? a : b))
  }

  function querySentiment() {
    const url = 'https://peacemindapi.lev99.com/journal-sentiment-analysis2'
    // const url = 'http://127.0.0.1:5000/journal-sentiment-analysis/'
    setSentiment('loading')
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify(content)
    })
      .then((response) => response.json())
      .then((data) => {
        const table = {
          NEG: 'negative',
          NEU: 'neutral',
          POS: 'positive'
        }

        const argmax = getMaxValueKey(data)
        const sent = table[argmax as keyof typeof table]

        setSentiment(sent)
      })
      .catch((err) => {
        console.log(JSON.stringify(err))
      })
  }

  return (
    <Layout>
      <MainTitle title="New Journal" />
      <input
        id="title"
        placeholder="title"
        className="my-1 mr-4 w-full rounded-2xl bg-primary py-2 px-3"
        onChange={(e) => setTitle(e.target.value)}
      />
      <input
        id="date"
        placeholder="date"
        value={convertTime(date)}
        className="my-1 mr-4 w-full rounded-2xl bg-primary py-2 px-3"
        onChange={(e) => setDate(new Date(e.target.value))}
      />
      <textarea
        id="content"
        placeholder=""
        rows={13}
        className="my-2 mr-4 w-full rounded-2xl bg-primary py-2 px-3 pb-24"
        onChange={(e) => setContent(e.target.value)}
      />
      <div className="flex justify-between">
        <button
          className="rounded-2xl bg-secondary py-2 px-6 text-white hover:bg-tertiary"
          onClick={querySentiment}
        >
          Check Sentiment
        </button>
        <div className="mt-4 flex w-full justify-center">
          {getIconBySentiment(sentiment, 72)}
        </div>
        <button
          className="w-40 rounded-2xl bg-secondary py-2 px-6 text-white hover:bg-tertiary"
          onClick={createJournal}
        >
          Save
        </button>
      </div>
    </Layout>
  )
}

export default NewJournal
